const loadCalEmbed = () => {
  if (window.Cal) return window.Cal;

  const queueCall = (api, args) => api.q.push(args);
  const document = window.document;

  window.Cal = function () {
    const cal = window.Cal;
    const args = arguments;

    if (!cal.loaded) {
      cal.ns = {};
      cal.q = cal.q || [];

      const script = document.createElement('script');
      script.src = 'https://app.cal.com/embed/embed.js';
      script.async = true;
      document.head.appendChild(script);

      cal.loaded = true;
    }

    if (args[0] === 'init') {
      const namespace = args[1];
      const api = function () {
        queueCall(api, arguments);
      };

      api.q = api.q || [];

      if (typeof namespace === 'string') {
        cal.ns[namespace] = cal.ns[namespace] || api;
        queueCall(cal.ns[namespace], args);
        queueCall(cal, ['initNamespace', namespace]);
      } else {
        queueCall(cal, args);
      }

      return;
    }

    queueCall(cal, args);
  };

  return window.Cal;
};

const CalEmbedHooks = {
  MarketingCalEmbed: {
    mounted() {
      const cal = loadCalEmbed();
      const namespace = 'flowmapDemo';

      cal('init', namespace, { origin: 'https://cal.com' });
      cal.ns[namespace]('inline', {
        elementOrSelector: `#${this.el.id}`,
        calLink: 'flowmap/demo',
        config: {
          layout: 'month_view',
          theme: 'light',
        },
      });
      cal.ns[namespace]('ui', {
        hideEventTypeDetails: false,
        layout: 'month_view',
        theme: 'light',
      });
    },
  },
};

export default CalEmbedHooks;
